import useGoToNavigation from "../../../../../util/useGotoNavigation";
import React from "react";
import {OrdersDetailType} from "../interface";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";

interface PropsType {
    ordersDetail: OrdersDetailType
    isModify: string
    tab: string
    btnToggleModify: () => any
    btnSave: () => any
    isDeadline: boolean | undefined
}

export default function Upper({ordersDetail, isModify, tab, btnToggleModify, btnSave, isDeadline}: PropsType) {
    const {goToNavigation} = useGoToNavigation();

    const goToList = () => {
        !isDeadline
            ? goToNavigation(`order/orders/list`, {}, false)
            : goToNavigation(`order/deadline/list`, {}, false)
    }

    return <div className="content_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">{!isDeadline ? "수주" : "마감"} 상세보기</h3>
            <div className="filter_toolbar">
                <button className="btn btn-outline-primary w-100px h-38px" onClick={goToList}>
                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt=""/>목록
                </button>
                {tab === "tab-1" && <>
                    {isModify === ""
                        //? <>{!isDeadline && (ordersDetail.newPProgress === 100000000 || ordersDetail.newPProgress === 100000001) &&
                        ? <>{!isDeadline && ordersDetail.newPProgress === 100000000 &&  // 내부수정: 수주 상태일 때만 수정 버튼 노출 (출하요청 제외)

                            <AuthorityChecker authorityNames={['shipmentWriteYn']}>
                                <button className="btn btn-secondary w-100px h-38px" onClick={btnToggleModify}>수정
                                </button>
                            </AuthorityChecker>
                        }
                        </>
                        : <>
                            <button className="btn btn-primary w-100px h-38px"
                                    onClick={btnSave}>저장
                            </button>
                            <button className="btn btn-outline-secondary w-100px h-38px"
                                    onClick={btnToggleModify}>취소
                            </button>
                        </>}
                </>}
            </div>
        </div>
        <h5 className="subheading">{!isDeadline ? "수주" : "마감"} 정보</h5>
        <div className="table_scroll mb-0">
            <table className="table table-bordered my_table table_detail">
                <tbody>
                <tr>
                    <th style={{width: "16.66%"}}>출하번호</th>
                    <td style={{width: "33.34%"}}>{ordersDetail.shipmentNo}</td>
                    <th style={{width: "16.66%"}}>상태</th>
                    <td>{ordersDetail.endState === "마감" ? "마감" : ordersDetail.progressName}</td>
                </tr>
                <tr>
                    <th>수주일자</th>
                    <td>{ordersDetail.newDtOrder}</td>
                    <th>요청자</th>
                    <td>{ordersDetail.chargeName}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
}